import { useEffect, useMemo } from 'react';
import { Tabs } from 'common/constants';
import { getDepartmentName } from 'components/StoreSelect/slice';
import { useFetchVendors, useFlags } from 'hooks';
import { getSelectedTab } from 'pages/LandingPage/components/LandingPageHeader/slice';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import {
  getRowData,
  getVendorsDataQueryOptions,
  setVendorsResponse
} from './slice';
import type { VendorsResponseDataType, VendorsTableDataResult } from './types';
import type { UseQueryResult } from 'react-query';

export const useVendorsTableData = (
  _refetchOnMount?: boolean
): VendorsTableDataResult => {
  const flags = useFlags();
  const dispatch = useAppDispatch();
  const currentRowData = useAppSelector(getRowData);
  const selectedTab = useAppSelector(getSelectedTab);
  const isApproved =
    selectedTab === Tabs.NeedsAuthorization &&
    !!flags.dmsAccountingThreeStepApproval;
  const isAuthorized = isApproved ? false : undefined;
  const { companyId, storeId, dueDate, paymentMethod } = useAppSelector(
    getVendorsDataQueryOptions
  );
  const selectedDepartmentName = useAppSelector(getDepartmentName);

  const queryResult: UseQueryResult<VendorsResponseDataType> = useFetchVendors(
    companyId,
    storeId,
    dueDate,
    paymentMethod,
    isApproved,
    isAuthorized,
    selectedDepartmentName
  );

  const rowData = useMemo(
    () => (queryResult.isLoading ? undefined : currentRowData),
    [currentRowData, queryResult.isLoading]
  );

  useEffect(() => {
    if (queryResult.data) {
      dispatch(setVendorsResponse(queryResult.data));
    }
  }, [dispatch, queryResult.data]);

  return {
    rowData,
    ...queryResult
  };
};
